module.exports = __webpack_public_path__ + "static/media/Rookies.39876cd1.svg";